// ChangeEmailModal.jsx
import LoadedText from "@/components/loader/LoadedText";
import LoadingText from "@/components/loader/LoadingText";
import { validateForm } from "@/utils/formValidator";
import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";

const SetPasswordModal = ({
  show,
  handleClose,
  onSubmit,
  loading = false,
  resetEveryThing,
}) => {
  const [formData, setFormData] = useState({
    password: "",
    confirmPassword: "",
  });
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState({
    password: false,
    confirmPassword: false,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const validationErrors = validateForm(formData, ["password"], true, true);

    // Extra check for matching passwords
    if (
      formData.password &&
      formData.confirmPassword &&
      formData.password !== formData.confirmPassword
    ) {
      validationErrors.confirmPassword = "Passwords do not match";
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors({});
    onSubmit(formData);
  };

  useEffect(() => {
    if (resetEveryThing) {
      setFormData({
        password: "",
        confirmPassword: "",
      });
      setShowPassword({
        password: false,
        confirmPassword: false,
      });
      setErrors({});
    }
  }, [resetEveryThing]);

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Set New Password</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit} noValidate>
          <Form.Group className="mb-3">
            <Form.Label>
              New Password<span className="text-danger">*</span>
            </Form.Label>
            <div className="position-relative">
              <Form.Control
                style={{ backgroundImage: "none" }}
                type={showPassword.password ? "text" : "password"}
                name="password"
                value={formData.password}
                onChange={handleInputChange}
                isInvalid={!!errors.password}
              />
              <span
                onClick={() =>
                  setShowPassword((prev) => ({
                    ...prev,
                    password: !prev.password,
                  }))
                }
                style={{
                  position: "absolute",
                  top: errors.password ? "30%" : "50%",
                  right: "10px",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  zIndex: 2,
                  color: "#6c757d",
                }}
              >
                {showPassword.password ? (
                  <i className="fa fa-eye" aria-label="Hide password"></i>
                ) : (
                  <i className="fa fa-eye-slash" aria-label="Show password"></i>
                )}
              </span>
              <Form.Control.Feedback type="invalid">
                {errors.password}
              </Form.Control.Feedback>
            </div>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>
              Confirm Password<span className="text-danger">*</span>
            </Form.Label>
            <div className="position-relative">
              <Form.Control
                style={{ backgroundImage: "none" }}
                type={showPassword.confirmPassword ? "text" : "password"}
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleInputChange}
                isInvalid={!!errors.confirmPassword}
              />
              <span
                onClick={() =>
                  setShowPassword((prev) => ({
                    ...prev,
                    confirmPassword: !prev.confirmPassword,
                  }))
                }
                style={{
                  position: "absolute",
                  top: errors.confirmPassword ? "35%" : "50%",
                  right: "10px",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  zIndex: 2,
                  color: "#6c757d",
                }}
              >
                {showPassword.confirmPassword ? (
                  <i className="fa fa-eye" aria-label="Hide password"></i>
                ) : (
                  <i className="fa fa-eye-slash" aria-label="Show password"></i>
                )}
              </span>

              <Form.Control.Feedback type="invalid">
                {errors.confirmPassword}
              </Form.Control.Feedback>
            </div>
          </Form.Group>

          <div className="d-flex justify-content-end gap-2">
            <Button
              variant="secondary"
              onClick={handleClose}
              disabled={loading}
              type="button"
            >
              Cancel
            </Button>
            <Button variant="primary" type="submit" disabled={loading}>
              {loading ? (
                <LoadingText text="Setting..." />
              ) : (
                <LoadedText text="Set Password" />
              )}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default SetPasswordModal;
